import { useQuery } from '@tanstack/react-query';

import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';
import { withGlobalError } from '@/react-tools/react-query';

import { Registry, RegistryTypes } from '../../types/registry';
import {
  getAllGitlabRepositories,
  getAllRepositories,
} from '../../registry.service';

export function useRegistryRepositories(
  registryId: Registry['Id'],
  registry?: Registry,
  options?: { enabled?: boolean }
) {
  const environmentId = useEnvironmentId(false);
  const isGitlab = registry?.Type === RegistryTypes.GITLAB;
  const gitlabProjectId = registry?.Gitlab?.ProjectId;

  return useQuery(
    ['environment', environmentId, 'registries', registryId, 'repositories'],
    () => {
      if (!registry) {
        throw new Error('Registry is required');
      }

      // Gitlab is a bit special, so it gets its own retrieval function
      if (isGitlab && gitlabProjectId) {
        return getAllGitlabRepositories(
          registry.Id,
          gitlabProjectId,
          environmentId
        );
      }

      return getAllRepositories(registry.Id, environmentId);
    },
    {
      ...options,
      ...withGlobalError(),
      enabled:
        options?.enabled !== false &&
        !!registry &&
        (!isGitlab || !!gitlabProjectId),
    }
  );
}
